export const DEFAULT_PRODUCT_DETAIL_FIELDS = [
    {label: 'Category', names: ['category', 'sub_category']},
    {label: 'Material', names: ['material']},
    {label: 'Finish', names: ['finish']},
    {label: 'Collection', names: ['collection']},
];

const formatVarLabel = (name = '') =>
    String(name)
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());

const normalizeNames = (names) => {
    const source = Array.isArray(names)
        ? names
        : typeof names === 'string'
            ? names.split(',')
            : [];

    return Array.from(
        new Set(
            source
                .map((name) => (typeof name === 'string' ? name.trim() : ''))
                .filter(Boolean),
        ),
    );
};

export const normalizeProductDetailFields = (settings, {fallbackToDefaults = true} = {}) => {
    const sourceFields = Array.isArray(settings)
        ? settings
        : Array.isArray(settings?.fields)
            ? settings.fields
            : null;

    if (!sourceFields) {
        return fallbackToDefaults
            ? DEFAULT_PRODUCT_DETAIL_FIELDS.map((field, index) => ({
                  id: field.names[0] || `field-${index}`,
                  label: field.label,
                  names: [...field.names],
                  enabled: true,
              }))
            : [];
    }

    return sourceFields
        .map((field, index) => {
            const names = normalizeNames(field?.names);
            const id = typeof field?.id === 'string' && field.id.trim()
                ? field.id.trim()
                : names[0] || `field-${index}`;
            const label = typeof field?.label === 'string' && field.label.trim()
                ? field.label.trim()
                : formatVarLabel(names[0] || id);

            if (!names.length) return null;

            return {
                id,
                label,
                names,
                enabled: field?.enabled !== false,
            };
        })
        .filter(Boolean);
};

export const resetProductDetailFieldSettings = () => ({
    fields: normalizeProductDetailFields(null).map((field) => ({...field})),
});

const getProductVarValue = (product, names) => {
    for (const name of names) {
        const value = product?.vars?.find((variable) => variable.name === name)?.sample;
        if (value) return value;
    }

    return '';
};

export const buildProductDetails = (product, settings = null) =>
    normalizeProductDetailFields(settings, {fallbackToDefaults: !settings})
        .filter((item) => item.enabled)
        .map((item) => ({
            label: item.label,
            value: getProductVarValue(product, item.names),
        }))
        .filter((item) => item.value);
